import type { BariPostEnrollmentDataV1 } from '@common/validation/customControls/bariPost/bariPostEnrollment/v1/bariPostEnrollmentDataV1';
import type { BariPostEnrollmentDataV2 } from '@common/validation/customControls/bariPost/bariPostEnrollment/v2/bariPostEnrollmentDataV2';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialDataV1 } from './v1/bariPostEnrollmentEditDataV1';
import { BariPostEnrollmentEditV1 } from './v1/BariPostEnrollmentEditV1';
import { BariPostEnrollmentReadV1 } from './v1/BariPostEnrollmentReadV1';
import { initialDataV2 } from './v2/bariPostEnrollmentEditDataV2';
import { BariPostEnrollmentEditV2 } from './v2/BariPostEnrollmentEditV2';
import { BariPostEnrollmentReadV2 } from './v2/BariPostEnrollmentReadV2';

const code = CustomControlCode.BariPostEnrollment;

CustomControlRegistry.instance.register<BariPostEnrollmentDataV1>({
    EditElement: BariPostEnrollmentEditV1,
    ReadElement: BariPostEnrollmentReadV1,
    canCopyReadSections: true,
    code,
    initialData: initialDataV1,
    version: 1,
});

CustomControlRegistry.instance.register<BariPostEnrollmentDataV2>({
    EditElement: BariPostEnrollmentEditV2,
    ReadElement: BariPostEnrollmentReadV2,
    canCopyReadSections: true,
    code,
    initialData: initialDataV2,
    version: 2,
});
